"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Star, Truck, Sparkles } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AustinsMobileSpaOnWheels() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="240186" id="master-your-financial-destiny" className="relative w-full bg-background py-16 md:py-24 lg:py-32 overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10 pointer-events-none">
        <div className="absolute -top-[20%] -left-[10%] w-[50%] h-[50%] rounded-md bg-primary/20 blur-3xl" />
        <div className="absolute top-[60%] -right-[10%] w-[40%] h-[60%] rounded-md bg-secondary/10 blur-3xl" />
      </div>

      <div className="container mx-auto px-4 md:px-6">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center">
          
          {}
          <div ref={textRef} className={`flex flex-col items-start space-y-8 transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-md bg-secondary text-secondary-foreground text-sm font-medium mb-2">
              <Sparkles className="size-4 text-primary" />
              <span>Lake Stone Enterprise, LLC</span>
            </div>
            
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-default font-bold text-foreground leading-tight tracking-tighter">
              Master Your <br className="hidden md:block" />
              <span className="relative inline-block mt-2">
                Financial Destiny
                {}
                <svg className="absolute -bottom-3 left-0 w-full h-4 text-primary/40 -z-10" viewBox="0 0 200 20" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
                  <path d="M2 15.5C45.5 4.5 120 -3.5 198 15.5" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
                </svg>
              </span>
            </h1>

            <p className="text-lg md:text-xl text-muted-foreground max-w-[600px] leading-relaxed font-default">
              Scale your business and personal credit with elite consulting. Get the funding you deserve and secure your legacy with Lake Stone's expert management.
            </p>

            <div className="pt-4 flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
              {}
              <div className="relative inline-flex group">
                <div className="absolute inset-0 rounded-md bg-primary animate-ping opacity-20 group-hover:opacity-40 transition-opacity duration-300"></div>
                <Link to="/ContactPage" className="relative z-10 w-full sm:w-auto">
                  <Button size="lg" variant="default" className="w-full sm:w-auto text-base h-14 px-8 shadow-xl bg-primary text-primary-foreground hover:shadow-primary/20">
                    Get Funded Now
                  </Button>
                </Link>
              </div>
              
              <Link to="/CreditSolutionsPage" className="w-full sm:w-auto">
                <Button size="lg" variant="outline" className="w-full sm:w-auto text-base h-14 px-8 bg-background/50 backdrop-blur-sm border-border hover:bg-secondary">
                  Credit Solutions
                </Button>
              </Link>
            </div>
            
            <div className="flex items-center gap-4 pt-6 border-t border-border w-full max-w-md">
              <div className="flex -space-x-3">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666336/img/client_executive_1.png" alt="Successful entrepreneur" className="w-10 h-10 rounded-md border-2 border-background object-cover" />
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666336/img/client_executive_2.png" alt="Business owner" className="w-10 h-10 rounded-md border-2 border-background object-cover" />
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666336/img/client_executive_3.png" alt="Consulting client" className="w-10 h-10 rounded-md border-2 border-background object-cover" />
              </div>
              <div className="flex flex-col">
                <div className="flex items-center gap-1 text-primary">
                  <Star className="size-4 fill-current" />
                  <Star className="size-4 fill-current" />
                  <Star className="size-4 fill-current" />
                  <Star className="size-4 fill-current" />
                  <Star className="size-4 fill-current" />
                </div>
                <span className="text-sm text-muted-foreground font-medium">ls@lakestoneenterprise.net</span>
              </div>
            </div>
          </div>

          {}
          <div ref={imageRef} className={`relative w-full max-w-[500px] mx-auto lg:max-w-none lg:ml-auto transition-all duration-1000 delay-200 ease-out ${isImageVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            {}
            <div className="relative aspect-square md:aspect-[4/5] w-full">
              <div className="absolute inset-0 bg-primary/10 rounded-md transform rotate-3 scale-105 -z-10 transition-transform duration-700 hover:rotate-1"></div>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666336/img/premium_credit_cards_cash.png" alt="Stacks of cash and premium metal credit cards representing financial growth" className="w-full h-full object-cover rounded-md shadow-4xl border-border" />
              
              {}
              <div className="absolute top-8 -left-4 md:-left-8 animate-[bounce_4s_ease-in-out_infinite]">
                <Badge variant="default" className="px-4 py-2 text-sm shadow-lg flex items-center gap-2 bg-card text-card-foreground border-border">
                  <Star className="size-4 text-primary fill-primary" />
                  Elite Consulting
                </Badge>
              </div>
              
              <div className="absolute bottom-12 -right-4 md:-right-8 animate-[bounce_5s_ease-in-out_infinite_reverse]">
                <Badge variant="secondary" className="px-4 py-2 text-sm shadow-lg flex items-center gap-2 border-primary/20">
                  <Truck className="size-4 text-primary" />
                  1-888-322-2844
                </Badge>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}